
<div class="PolicyContainer">
  <header>
    <h1>Privacy Policy</h1>
  </header>
  <section class="policy-content">
    <p>{{Company_Name}} is a financial services company located at {{Company_Address}}. For simplicity, we will refer to it as the “Company.” The Company provides services through its website {{Domain}} and mobile application {{Company_Name}} (together called the "Platform"). Individuals using the Platform are referred to as “You” or “Your.” Protecting your personal information and maintaining the security of your interactions with the Platform is a top priority for us.</p>

    <p>We work with technology partners and affiliates, including Optimum Financial Solutions Pvt. Ltd., who may assist in operating and managing the Platform in line with the policy at {{Domain}}/privacy_policy.</p>

    <p>This Privacy Policy describes how we collect, store, process, share, and manage your personal data. It does not apply to information you provide to other third-party websites or services you may access from the Platform.</p>

    <p>By accessing or using the Platform, including services such as mutual fund distribution, stockbroking, investment advice, or KYC verification, you agree to this Privacy Policy. It complements and is part of the Platform’s Terms of Use.</p>

    <h4>Our Promise to You</h4>
    <p>We may collect certain information that can identify you, referred to as “Personal Data.” Publicly available information is not included in this category. Your privacy is important, and we handle all Personal Data with care.</p>

    <h3>1. Access Before Registration</h3>
    <p>Some areas of the Platform require registration. We may collect anonymous usage data to analyze how the Platform is used. This helps improve services and monitor usage patterns in the regions where we operate.</p>

    <h3>2. Account Registration</h3>
    <p>To use the Platform fully, you must create an account with a unique username and password.</p>

    <h3>3. Investment Services</h3>
    <ul>
      <li>Personal and contact information (name, age, email, father’s name, etc.)</li>
      <li>Mailing and residential address</li>
      <li>Bank account information for investment purposes</li>
      <li>Documents required under KYC regulations, such as PAN or Aadhaar</li>
    </ul>
    <p>This information will be referred to as your "Registration Information." Verification of your bank account may require providing a copy of the first page of your passbook or a cancelled cheque.</p>

    <!-- <p>To track investments outside the Platform, you may provide your registered email with mutual fund accounts. Our system accesses only emails with the subject "CONSOLIDATED ACCOUNT STATEMENT - CAMS/KARVY Mail back Request". All other emails remain private. Alternatively, you can upload investment statements manually.</p> -->

    <p>The Company complies with applicable Indian laws, including the Information Technology Act 2000 and the IT Rules 2011 concerning sensitive personal data.</p>

    <p>{{Company_Name}} is a registered Mutual Fund Distributor. Your information may be shared with regulatory authorities, Asset Management Companies (AMCs), Registrar and Transfer Agents (RTAs), KYC Registration Agencies, and the Central KYC Registry to comply with legal requirements. Third-party providers are subject to their own privacy policies.</p>

    <h4>Personal Data Collected</h4>
    <ul>
      <li>Identification details, Gender, Date of Birth, Email Address, Phone Number, Address, and education records</li>
      <li>Transaction history, account balances, and payment information via NSE/BSE</li> <!-- /MFU-->
      <li>Financial information, bank mandates, and income details</li>
      <li>Document images or photographs</li>
      <li>Employment information, including occupation, experience, salary, and benefits</li>
      <li>Signatures or consents to process instructions</li>
      <li>Feedback, survey responses, and mobile device information (location, OS, model, notifications)</li>
    </ul>
    <p>You agree that we may obtain or update personal details from government or regulated agencies when required.</p>

    <p> It's mandatory to provide exact Date of Birth (DOB) and Gender for mutual funds due to stringent KYC (Know Your Customer) norms,
      primarily for investor protection, fraud prevention, and regulatory compliance (like SEBI rules) to verify identity against 
      documents like PAN, ensuring transactions are legitimate, preventing money laundering, and correctly identifying investors for 
      tax/reporting purposes, with mismatches leading to transaction rejection. DOB helps confirm age (especially for minors/seniors) 
      and identity, while Gender aids demographic/risk profiling, linking all financial data accurately. 
    </p>

    <h4> Key Reasons for Collecting DOB & Gender: </h4>

    <h3>1. Regulatory Compliance (KYC/AML):</h3>
    <ul>
      <li>Investor Protection: Prevents misuse of accounts and safeguards funds.</li>
      <li>Anti-Money Laundering (AML): Helps financial intermediaries verify customer identity as required by law.</li>
      <li>Identity Verification: Matches details with official records (PAN, Aadhaar) to ensure you are who you say you are, preventing identity fraud.</li>
    </ul>

    <h3>2. Age-Based Rules & Suitability:</h3>
    <ul>
      <li>Age Verification: Confirms investors meet minimum age requirements (e.g., 18 for direct investment) or qualify for specific schemes (senior citizen funds).</li>
      <li>Minor Investments: Crucial for managing investments in a minor's name where a guardian handles it, requiring correct age/relationship details.</li>
    </ul>

    <h3>3. Accurate Data & Transaction Processing:</h3>
    <ul>
      <li>Data Consistency: Ensures name, DOB, and gender match across all financial documents (PAN, bank, etc.) to avoid transaction rejections.</li>
      <li>Relationship Mapping: Prevents errors in mapping family members (spouse, child) for financial transactions.</li>
    </ul>

    <h3>4. Risk Profiling & Reporting:</h3>
    <ul>
      <li>Demographic Data: Gender information helps in demographic analysis, risk assessment, and regulatory reporting by fund houses.</li>
      <li>In essence, these details aren't just form-filling; they are critical data points for regulatory adherence, security, and ensuring seamless, accurate financial operations.</li>
    </ul>

    <!-- <h4>Data Storage</h4>
    <p>All Personal Data is stored and processed exclusively in India, using systems with backup and disaster recovery capabilities.</p> -->

    <h4>Sharing Your Information</h4>
    <ul>
      <li>To provide services you have requested, on a strict "need-to-know" basis</li>
      <li>As required by legal, regulatory, or governmental authorities</li>
      <li>To prevent fraud, manage risk, or recover funds</li>
      <li>When using the Platform for investment services, your data may be accessible to AMCs, RTAs, and their service providers</li>
    </ul>

    <h4>How We Use Your Data</h4>
    <ul>
      <li>Facilitate transactions and maintain records</li>
      <li>Conduct research and improve Platform security and services</li>
      <li>Process requests or instructions from you</li>
      <li>Notify you of changes to services or terms</li>
      <li>Investigate complaints or disputes</li>
      <li>Verify your identity</li>
      <li>Conduct credit, compliance, or due diligence checks</li>
      <li>Monitor services and maintain risk management systems</li>
      <li>Offer relevant promotions</li>
      <li>Fulfill legal, regulatory, or court requirements</li>
    </ul>

    <h4>Account Deactivation or Deletion</h4>
     <p>You may deactivate or delete your account anytime via the web portal. After deactivation, we stop sharing your data. Certain data may be retained for legal compliance, such as SEBI Investment Advisers Regulations 2013 and PMLA rules, typically up to five years.</p><!--, mobile site, or app -->

    <h4>Cookie Policy</h4>
    <p>Cookies are small data files saved on your browser to improve functionality. Cookies do not collect new Personal Data unless you have already shared it.</p>

    <h4>Links to Other Websites</h4>
    <p>The Platform may link to external sites not managed by us. This Privacy Policy does not apply to those sites. Please review their privacy policies separately.</p>

    <h4>Security Measures</h4>
    <p>We implement strong security protocols, encryption, and access controls. Features include AppLock, device binding, and OTP verification. Do not share login credentials or OTPs with anyone.</p>

    <h4>Contact Us</h4>
    <p>The Compliance Officer<br />
    {{Company_Name}}<br />
    {{Company_Address}}<br />
    {{Company_Email}}</p>

    <h4>Policy Updates</h4>
    <p>This Privacy Policy may be updated at any time. The latest version is available at {{Domain}}/privacy_policy. We encourage periodic review to stay informed.</p>

    <h4>Applicability</h4>
    <p>This policy applies to {{Company_Name}} ’s web portal, mobile application, and WAP site.</p>
  </section>
</div>
